import { render, staticRenderFns } from "./GeneralInfoTable.vue?vue&type=template&id=36fef97c&"
import script from "./GeneralInfoTable.vue?vue&type=script&lang=js&"
export * from "./GeneralInfoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports